import { StringBufAggsUtf8, UTF8_STATUS } from '../str-buf/getHistoAndBasicAggs.types';
import { utf8d } from '../str-buf/utf8d';
import { isStr } from '../utils/common';

export function _analyzeUtf8(
	matches: IterableIterator<RegExpMatchArray>,
	inputLength: number,
	isPartialData = false
): StringBufAggsUtf8 {
	const aggs: StringBufAggsUtf8 = {
		allAscii: true,
		utf8State: UTF8_STATUS.ACCEPT,
		validUtf8: true,
		length: inputLength,
		numInvalidUtf8Seqs: 0,
		numValidUtf8Seqs: 0,
	};

	let len, i, byte, utf8State, newUtf8State;
	for (const match of matches) {
		aggs.allAscii = false;

		// Reset state since a new sequence of high bytes
		utf8State = UTF8_STATUS.ACCEPT;

		len = match[0].length;
		for (i = 0; i < len; ++i) {
			byte = match[0].charCodeAt(i);

			// We don't care about the codepoint, so this is
			// a simplified version of the decode function.
			newUtf8State = utf8d[256 + utf8State * 16 + utf8d[byte]];

			if (newUtf8State === UTF8_STATUS.REJECT) {
				++aggs.numInvalidUtf8Seqs;

				// Reset state
				utf8State = UTF8_STATUS.ACCEPT;
			} else {
				if (utf8State !== UTF8_STATUS.ACCEPT && newUtf8State === UTF8_STATUS.ACCEPT) {
					++aggs.numValidUtf8Seqs;
				}
				utf8State = newUtf8State;
			}
		}

		if (utf8State !== UTF8_STATUS.ACCEPT) {
			// If this sequence ends early, it is either a bad sequence, or the overall string
			// is truncated (not really known whether good or bad sequence... depends on more data or not)

			// Record the ending state if this sequence ends the overall string
			if (match.index! + len === inputLength) {
				// This sequence ends the string
				aggs.utf8State = utf8State;

				if (!isPartialData) {
					++aggs.numInvalidUtf8Seqs;
				}
			} else {
				++aggs.numInvalidUtf8Seqs;
			}
		}
	}

	aggs.validUtf8 = aggs.numInvalidUtf8Seqs === 0 && aggs.utf8State === UTF8_STATUS.ACCEPT;

	return aggs;
}

export function analyzeUtf8(input: string | Buffer, isPartialData = false): StringBufAggsUtf8 {
	const str = isStr(input) ? input : input.toString('binary');

	const highSequences = str.matchAll(/[\x80-\xFF]+/g);

	return _analyzeUtf8(highSequences, str.length, isPartialData);
}
